import styled from 'styled-components';

export const DividerWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 0px 40px;

  @media (${({ theme }) => theme.media.tabletPortraitMin}) {
    display: none;
  }
`;

export const Line = styled.div`
  flex: 2;
  height: 1px;
  background-color: #c8ccd1;
`;

export const OrText = styled.span`
  margin: 0 12px;
  font-weight: 500;
  font-size: 18px;
  color: #252c34;
  text-transform: lowercase;
`;
